export default {
  name: "ChevronLeft",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M20.71 25.29a1 1 0 1 1-1.41 1.41l-10-10a1 1 0 0 1 0-1.41l10-10a1 1 0 1 1 1.41 1.41l-9.3 9.3 9.3 9.29z",
  },
}
